module.exports = __webpack_public_path__ + "static/img/neanderthals.3947777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/neanderthals.png
// module id = HPls
// module chunks = 1